/**
 * @author Owais Liaquat Ali
 * @datetime Sep, 15th 2022
 * @description: This is lock management service that is responsible for
 *                API calling related to lock management
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { ILock } from './lock-management-interfaces';
import { TranslateService } from '@ngx-translate/core';
import {CommonService} from "src/app/shared/utils/common.service"
@Injectable({
  providedIn: 'root',
})
export class LockManagementService {
  private url = environment.graphqlUrl;

  constructor(private http: HttpClient, private translate: TranslateService, private commonService: CommonService) {}

  /**
   * @description this method calls API to add lock to unit
   * @param { ILock } createLock variables of type ILock to give lock object
   * @returns
   */
  createLock(createLock: ILock): Observable<any> {
    return this.http
      .post<any>(`${this.url}`, {
        query: `mutation addDevice($deviceId: String!, $deviceName: String!, $unitId: String!) {  addDevice(deviceId: $deviceId, deviceName: $deviceName, unitId: $unitId) {    deviceId  }}`,
        variables: createLock,
      })
      .pipe(
        map((res) => {
          try {
            if (res?.data && res?.data?.addDevice?.deviceId) {
              return res?.data?.addDevice?.deviceId;
            } else if (res?.errors?.length > 0) {
              let errorList = res?.errors.map((x: any) => x.message)[0];
              if (errorList.includes('Lock name already exists')) {
                throw new Error(
                  this.translate.instant('LOCK_NAME_ALREADY_EXIST')
                );
              } else if (errorList.includes('deviceId')) {
                throw new Error(
                  this.translate.instant('YOU_MUST_ENTER_SERIAL_NUMBER')
                );
              } else if (errorList.includes('deviceName')) {
                throw new Error(
                  this.translate.instant('YOU_MUST_ENTER_LOCK_NAME')
                );
              } else if (this.commonService.normalizeString(errorList).includes(this.translate.instant('DEVICE_LIMIT_EXCEEDED'))) {
                throw new Error(
                  this.translate.instant('DEVICE_LIMIT_EXCEEDED')
                );
              } else if (
                errorList.includes(
                  'Lock with same serial number already exists'
                )
              ) {
                throw new Error(
                  this.translate.instant('DEVICE_ID_ALREADY_EXISTS')
                );
              } else if (
                errorList.includes('Lock is already present in the system')
              ) {
                throw new Error(
                  this.translate.instant('DEVICE_ALREADY_EXISTS')
                );
              } else if (errorList.includes('Lock is already associated')) {
                throw new Error(errorList);
              } else if (
                errorList.includes('Maximum number of Locks allowed')
              ) {
                throw new Error(errorList);
              }
              throw new Error(
                this.translate.instant('FAILED_TO_ADD_DEVICE_SERVER_ERROR')
              );
            }
          } catch (error: any) {
            throw new Error(error?.message);
          }
        })
      );
  }
}
